var _rect, _path, _circle, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 29,
    viewBox: "0 0 44 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.844727,
    y: 0.00439453,
    width: 42.1698,
    height: 28.4526,
    rx: 4,
    fill: "url(#paint0_linear_14118_56162)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04834 21.3692C5.04834 22.0471 5.5979 22.5967 6.27581 22.5967H20.6653C21.3432 22.5967 21.8928 22.0471 21.8928 21.3692C21.8928 17.9796 19.145 15.2319 15.7554 15.2319H11.1857C7.79612 15.2319 5.04834 17.9796 5.04834 21.3692Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6227,
    cy: 10.1506,
    r: 4.28583,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0664,
    y: 10.5669,
    width: 11.7477,
    height: 1.95801,
    rx: 0.979007,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8491,
    y: 14.519,
    width: 12.1828,
    height: 1.95801,
    rx: 0.979007,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.061,
    y: 18.4189,
    width: 7.75931,
    height: 1.95801,
    rx: 0.979007,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14118_56162",
    x1: 8.42597,
    y1: -1.76942,
    x2: 36.3947,
    y2: 30.8241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA64C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D458A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.eb5c36a536d7345dab9640e6002a6f33.svg";
export { ForwardRef as ReactComponent };